module.exports = __webpack_public_path__ + "static/media/Grafico_black.52c6a32a.svg";